import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column, VerticalRhythm } from 'mage-components';
import { SpacerVertical } from '@klarna/bubble-ui';

import { ProductCard, ProductCardExpanded } from '@/components/ProductCard';

export const ProductSelectionOneKlarnaWrapper = ({
  t,
  onChange,
  products,
  isAddingProducts,
  isSelectedFn,
  isInstalledFn,
  extraAttributesToProductFn,
  shouldShowExpandedProductCard,
}) => {
  const productsOne = products.filter(p => p.id.includes('one'));
  const compatibleProducts = productsOne.filter(p => p.isCompatible);

  return (
    <>
      <Row>
        {!shouldShowExpandedProductCard ? (
          <>
            {productsOne.length > compatibleProducts.length && (
              <SpacerVertical spaceToken="space/150" />
            )}
            {productsOne.map(product => (
              <Column columns={{ tablet: 6, mobile: 12 }} key={`card-for-product-${product.id}`}>
                <ProductCard
                  extraAttributesToProductFn={extraAttributesToProductFn}
                  isAddingProducts={isAddingProducts}
                  isInstalledFn={isInstalledFn}
                  isSelectedFn={isSelectedFn}
                  onChange={onChange}
                  product={product}
                  t={t}
                />
              </Column>
            ))}
          </>
        ) : (
          <Column columns={{ mobile: 12 }} key={`card-for-product-${compatibleProducts[0].id}`}>
            <ProductCardExpanded
              extraAttributesToProductFn={extraAttributesToProductFn}
              isAddingProducts={isAddingProducts}
              isInstalledFn={isInstalledFn}
              isSelectedFn={isSelectedFn}
              onChange={onChange}
              product={compatibleProducts[0]}
              t={t}
            />
          </Column>
        )}
      </Row>
      <VerticalRhythm spacing={6} />
    </>
  );
};

ProductSelectionOneKlarnaWrapper.propTypes = {
  extraAttributesToProductFn: PropTypes.func.isRequired,
  isSelectedFn: PropTypes.func.isRequired,
  shouldShowExpandedProductCard: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isAddingProducts: PropTypes.bool,
  isInstalledFn: PropTypes.func,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ),
};
